import { isBoolean, isEqual } from 'lodash'
import { createSelector } from 'reselect'
import Device from '@config/device'
import { TERRA_APPLE_HEALTH, TerraProvider } from '@src/screens/Settings/models/settings.types'
import { integrationsSyncSettingsSelector, settingsSelector } from './settings'

//health selectors
export const healthKitSyncStatusSelector = createSelector(settingsSelector, (settings) =>
  isBoolean(settings.healthKitSync) ? settings.healthKitSync : Device.hasHealthKit,
)

export const healthLastSyncedSelector = createSelector(
  integrationsSyncSettingsSelector,
  (app) => app.lastSyncedHealth,
)

// KetoMojo selectors
export const ketoMojoUserSelector = createSelector(
  integrationsSyncSettingsSelector,
  (app) => app.ketoMojoUser,
  {
    memoizeOptions: {
      resultEqualityCheck: isEqual,
    },
  },
)

export const ketoMojoSyncStatusSelector = createSelector(
  [settingsSelector, ketoMojoUserSelector],
  (settings, ketoMojoUser) => settings.ketoMojoSync && !!ketoMojoUser?.accessToken,
)

export const ketoMojoLastSyncedSelector = createSelector(
  integrationsSyncSettingsSelector,
  (app) => app.lastSyncedKetoMojo,
)

export const terraProvidersSelector = createSelector(
  settingsSelector,
  (settings) => settings.terraProviders,
)

export const terraProviderSelector = createSelector(
  settingsSelector,
  (settings) => (providerId?: string) =>
    (settings.terraProviders.find((provider: TerraProvider) => provider.provider === providerId) ||
      {}) as TerraProvider,
)

// True once the user has migrated Apple Health to Terra. Apple Health data then
// flows in through Terra, so the native HealthKit push must not run as well —
// otherwise every metric is ingested twice (source "healthkit" and "apple").
export const terraAppleHealthActiveSelector = createSelector(
  terraProvidersSelector,
  (terraProviders) =>
    terraProviders.some(
      (provider: TerraProvider) => provider.name === TERRA_APPLE_HEALTH && provider.active,
    ),
)

export const dailyMeasurementsSourcePrioritiesSelector = createSelector(
  settingsSelector,
  (settings) => {
    return settings.dailyMeasurementsSourcePriorities
  },
)
